export const textfield = {
    base: {
        background: "red",
        color: "white",
    },
}